import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { CreateUnitPoolCorrection } from "Features/UnitPoolCorrection";
import { useTranslation } from "react-i18next";

function NewUnitPoolCorrection () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.newUnitPoolCorrection")} />
            <CreateUnitPoolCorrection />
        </Container>
    );
}

export default NewUnitPoolCorrection;